import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {
  AgGridComponentFrameworkComponent
} from "../../../../../shared/components/ag-grid/ag-grid-component-framework/ag-grid-component-framework.component";
import {CellSourceComponent} from "../../../../../shared/components/cell-source/cell-source.component";
import {Serializer} from "../../../../../shared/interfaces/serializer";
import {DataSetMetricsGroup} from '../../../../../shared/interfaces/metrics';
import {
  AgGridTemplateFrameworkComponent
} from "../../../../../shared/components/ag-grid/ag-grid-template-framework/ag-grid-template-framework.component";
import {TranslateService} from "@ngx-translate/core";
import {AppService} from "../../../../../shared/services/app.service";
import {AppState} from "../../../../../shared/store/store";
import {Store} from "@ngrx/store";
import {Observable} from "rxjs";
import {
  DatasetMetricsGroupComponentObject,
  DatasetMetricsGroupComponentObjects
} from '../../../../../shared/classes/dataset-metrics-group-component-object';
import {
  selectDataSetMetricsGroupComponentObjects,
  selectDataSetMetricsGroupsLoading
} from '../../../../../shared/store/dataSetMetricsGroups/dataSetMetricsGroups.selectors';
import {CreateMetricsGroupDialogComponent} from '../create-metrics-group-dialog/create-metrics-group-dialog.component';
import {dialogOpen} from '../../../../../shared/store/dialog/dialog.actions';
import {DialogConfirmComponent} from '../../../../../shared/components/dialog/dialog-confirm/dialog-confirm.component';
import {
  deleteDataSetMetricsGroup,
  deleteDataSetMetricsGroupSuccess
} from '../../../../../shared/store/dataSetMetricsGroups/dataSetMetricsGroups.actions';

@Component({
  selector: 'app-metrics-category-table',
  templateUrl: './metrics-category-table.component.html',
  styleUrls: ['./metrics-category-table.component.scss']
})
export class MetricsCategoryTableComponent implements OnInit {
  @ViewChild('name') private readonly _nameTemplate: TemplateRef<any>;
  @ViewChild('count') private readonly _countTemplate: TemplateRef<any>;
  @ViewChild('groupActionsColumn') private readonly groupActionsT: TemplateRef<any>;

  public readonly metricsGroupsColumnDefs: Array<any> = [
    {
      minWidth: 200,
      sortable: true,
      filter: 'agTextColumnFilter',
      lockPosition: true,
      headerValueGetter: _ => this._translateS.instant('settings.category'),
      filterValueGetter: params => params.data.payload.attributes.name,
      valueGetter: params => params.data.payload.attributes.name,
      cellRendererFramework: AgGridTemplateFrameworkComponent,
      cellRendererParams: _ => {
        return {
          ngTemplate: this._nameTemplate
        };
      }
    },
    {
      minWidth: 200,
      sortable: true,
      filter: 'agNumberColumnFilter',
      lockPosition: true,
      headerValueGetter: _ => {
        return this._translateS.instant('settings.metrics');
      },
      valueGetter: params => params.data.payload.attributes.metrics_number,
      filterValueGetter: params => params.data.payload.attributes.metrics_number,
      cellRendererFramework: AgGridTemplateFrameworkComponent,
      cellRendererParams: _ => {
        return {
          ngTemplate: this._countTemplate
        };
      }
    },
    {
      minWidth: 200,
      sortable: false,
      filter: false,
      lockPosition: true,
      suppressMenu: true,
      cellRendererFramework: AgGridTemplateFrameworkComponent,
      cellRendererParams: _ => {
        return {
          ngTemplate: this.groupActionsT
        };
      }
    }
  ];

  public readonly defaultColDef: any = {
    resizable: true,
    suppressNavigable: true,
    suppressCellSelection: true,
    menuTabs: ['filterMenuTab'],
    filterParams: {
      buttons: ['reset']
    }
  };

  public categories$: Observable<DatasetMetricsGroupComponentObjects> = this._store.select(selectDataSetMetricsGroupComponentObjects);
  public loading$: Observable<boolean> = this._store.select(selectDataSetMetricsGroupsLoading);

  constructor(
    private readonly _store: Store<AppState>,
    private readonly _translateS: TranslateService,
    public readonly appS: AppService
  ) { }

  ngOnInit(): void {}

  public onUpdate(category: DatasetMetricsGroupComponentObject): void {
    this._store.dispatch(dialogOpen({
      component: CreateMetricsGroupDialogComponent,
      config: {
        width: '600px',
        height: 'auto'
      },
      data: {
        category: category.payload,
      }
    }));
  }

  public onDelete(group: DatasetMetricsGroupComponentObject): void {
    this._store.dispatch(dialogOpen({
      component: DialogConfirmComponent,
      data: {
        title: 'metrics.delete_metrics_group_title',
        message: 'metrics.delete_metrics_group_message',
        type: 'delete',
        startActions: [deleteDataSetMetricsGroup],
        successActions: [deleteDataSetMetricsGroupSuccess],
        item: group.payload,
        onSubmit: () => {
          this._store.dispatch(deleteDataSetMetricsGroup({
            group: group.payload as Serializer<DataSetMetricsGroup>
          }));
        }
      },
      config: {
        width: '500px',
        height: 'auto'
      }
    }));
  }

}
